import { PermissionsService } from 'app/service/permission/permissions.service';
import { HttpClient, HttpParameterCodec } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Rx';
import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate, } from '@angular/router';
import { AuthenticationService, AlfrescoApiService, AuthGuardEcm } from '@alfresco/adf-core';
import { AlfrescoApi } from '@alfresco/js-api';
import { EventEmitterService } from 'app/service/event-emitter-service';

// import { AuthService } from './../login/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  AlfrescoAPI = environment.AlfrescoAPI;
  public retorno = true;

  constructor(
    private permission: PermissionsService,
    private authService: AuthenticationService,
    private router: Router,
    ) {  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    // console.log(route);
    // console.log(state);
    const ticket = sessionStorage.getItem('ticket-ECM');
    const value = this.isLogged(ticket, state, route);
    // console.log('isLogged  :', value);
    // return true;
    if (value === true) {
      return true;
    } else {
      return false;
    }
  }

  isLogged(ticket, state, route) {
    this.permission.getIsLogged(ticket).subscribe(data => {
      this.retorno =  true;
      EventEmitterService.get('isLoggedIn').emit(true);
    }, err => {

      EventEmitterService.get('isLoggedIn').emit(false);
      sessionStorage.clear();
      localStorage.clear();
      this.authService.logout();
      sessionStorage.setItem('routerpast', state.url);
      if (route.params != null) {
        sessionStorage.setItem('params', route.params.id);
      }
      //sessionStorage.setItem('params', state.params.id);
      // this.router.navigate(['login']);
      window.location.href = '/login';
      this.retorno = false;
    });
    return this.retorno;
  }
}



// WEBPACK FOOTER //
// /app/src/app/guards/auth.guard.ts